<template>
  <BreadCrumb :items="breadcrumbItems" />
  <main id="main">
    <FuneralInvitationForm />
  </main>
</template>
<script>
import FuneralInvitationForm from '@/components/funeral/FuneralInvitationForm.vue';
import BreadCrumb from "../layout/navigation/BreadCrumb.vue";

export default {
  data() {
    return {
      breadcrumbItems: [
        { href: "/", text: "홈", isHome: true },
        { href: "#", text: "부고장" },
      ],
    };
  },
  components: {
    BreadCrumb,
    FuneralInvitationForm
  }
}
</script>
<style>
    
</style>